<!--
 * @Author: your name
 * @Date: 2021-07-02 10:35:18
 * @LastEditTime: 2021-07-14 17:17:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\foodColumn\searchResult.vue
-->
<template>
  <div class="commonSearch">
    <div class="searchBox" ref="searchBox">
      <div class="search-backicon">
        <span class="goback-background" @click="onCancel"></span>
      </div>
      <form action="javascript:return true">
        <van-search
          :left-icon="require('./../../../assets/images/icon/search.png')"
          class="vanSearch"
          v-model="searchText"
          shape="round"
          @search="onSearch"
          @input="searchInput"
          @focus="searchFocus"
          maxlength="50"
          @clear="clear"
        />
      </form>
      <span class="canBtn" @click="onSearch">搜索</span>
    </div>
    
    <van-list
      class="list"
      v-model="searchLoadingObj.expertLoading"
      :finished="searchLoadingObj.expertFinished"
      :finished-text="searchLoadingObj.finishText"
      :error.sync="searchLoadingObj.expertError"
      :error-text="searchLoadingObj.expertErrorText"
      @load="getSearchList"
      :style="TestUserAgent().isios ? '' : { marginTop: '40px' }"
    >
      <ul class="searchList">
        <li class="searchItem" v-for="(item,index) in articleList" :key="index" @click="clickRusult(item,index)">
          <span class="imgWrap">
            <img :src="item.imgUrl" alt="" class="bg">
            <img src="./../../../assets/images/icon/off.png" alt="" class="off">
          </span>
          <span class="title" v-html="item.recipe_name"></span>
          <span class="label" v-for="(tagItem,index) in item.recipeTag" :key="index">{{tagItem}}</span>
          <div class="bottom">
            <span class="bottomItem"><img src="./../../../assets/images/food/collect.png" class="icon icon1"/><span>{{fomatterNum(item.collect)}}</span></span>
            <span class="bottomItem"><img src="./../../../assets/images/food/browse.png" class="icon"/><span>{{fomatterNum(item.play_num)}}</span></span>
          </div>
        </li>
      </ul>
    </van-list>
    <!-- 搜索内容不存在 -->
    <search-unfind
      ref="unfind"
      :keyWord="searchText"
      searchType="foodColumn"
      v-show="!noContent"
    ></search-unfind>
  </div>
</template>

<style lang="less" scoped>
.commonSearch {
  width: 100%;
  min-height: 100%;
  background: #fff;
  .searchBox {
    background: @expertFontColor255;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    display: flex;
    align-items: center;
    .search-backicon {
      width: 35px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .goback-background {
      width: 9px;
      height: 16px;
      background-image: url("./../../../assets/images/home/search-back.png");
      background-size: 100% 100%;
      background-position: center;
    }
    .van-search__action {
      font-size: @indexFontSize14;
    }
    .van-field__control {
      padding-left: 2px;
    }
    @media screen and (max-width: 640px) {
      .van-search {
        width: 291px;
        padding: 12px 0;
      }
    }
    span.canBtn {
      margin-left: 15px;
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #d4a437;
      line-height: 14px;
    }
  }
  /deep/ .van-search {
    width: 291px;
    padding: 0;
    font-size: @indexFontSize12;
  }
  /deep/ .van-cell {
    width: 291px;
  }
  .searchList{
    padding: 12px 14px;
    margin-top: 58px;
    // flex-wrap: wrap;
    // justify-content: space-between;
    // display: flex;
    .searchItem{
      // margin-left: 10px;
      box-sizing: border-box;
      width: 100%;
      // height: 183px;
      border-radius: 4px;
      border: 1px solid #f2f2f2;
      margin-bottom: 10px;
      background: #fff;
      .imgWrap{
        display: flex;
        position: relative;
        .bg{
          width: 100%;
          height: 190px;
          border-radius: 5px 5px 0 0;
        }
        .off{
          width: 40px;
          height: 40px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
      .title{
        font-size: 14px;
        font-weight: 400;
        margin: 10px 0 0 8px;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .label{
        margin-left: 5px;
        margin-top: 5px;
        color: #f1ba3b;
        background: #fff2d5;
        font-size: 12px;
        display: inline-flex;
        padding: 1.5px 10px;
        min-width: 37px;
        height: 18px;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
      }
      .bottom{
        margin: 7px 0 10px;
        .bottomItem{
          font-size: 12px;
          margin-left: 10px;
          color: #999;
          .icon{
            width: 12px;
            height: 10px;
            margin-right: 3px;
            vertical-align: middle;
          }
          .icon1{
            width: 10px;
          }
          span{
            vertical-align: -9%;
          }
        }
      }
    }
  }
  /deep/ .van-list__finished-text {
    background: #fff;
  }
}
</style>


<script>
import {
  fomatterNum,
  TestUserAgent,
  Debounce,
  uniqueArr
} from "@/assets/js/common.js";
import API from "@/utils/axiosApi/searchApi";
import searchUnfind from "@/components/common/unfind.vue";
import { setTimeout } from 'timers';
export default {
  name: "foodSearchResult",  
  data() {
    return {
      searchText: this.$route.query.searchText || "",
      searchResultParams: {
        size: 25,
        page: 1,
      },
      searchLoadingObj: {
        expertLoading: false,
        expertFinished: false,
        finishText: "",
        expertError: false,
        expertErrorText: "请求失败，点击重新加载",
      },
      articleList: [],
      noContent: true,
      historyVal:[]
    }
  },
  components:{ searchUnfind },
  mounted(){
    localStorage
      .getItem("historyList")
      .split(",")
      .forEach((item) => {
        this.historyVal.push(item.length > 6 ? item.slice(0, 6) + "..." : item);
      });
  },
  methods: {
    onSearch: Debounce(function () {
      if (this.searchText !== "") {
        this.searchLoadingObj.expertLoading = false;
        this.searchLoadingObj.expertFinished = false;
        this.articleList = [];
        this.searchResultParams.page = 1;
        var historyFlag = false;
        this.historyVal.forEach((item) => {
          if (item == this.searchText) {
            historyFlag = true;
          }
        });
        if ( this.searchText != "" && this.searchText.replace(/\s*/g, "") != "") {
          sensors.track("SentSearch", {
            key_word: this.searchText,
            is_history: historyFlag,
            search_number: 0,
            classification: '辅食专栏',
            is_Hot_search: false,
          });
        }
        this.getSearchList();
        // 存放搜索词
        var list = localStorage.getItem("historyList").split(",");
        list.unshift(this.searchText);
        list = this.uniqueArr(list);
        if (list.length > 10) {
          list = list.slice(0, 10);
        }
        localStorage.setItem("historyList", list.join(","));
      }
    },300),
    searchInput(){
      this.noContent = true;
      if (this.searchText == "") {
        this.$router.push({
          path: "/foodColumn/search",
        }); 
      } else if (this.searchText.length >= 50) {
        this.searchText = this.searchText.slice(0, 50);
      }
    },
    searchFocus(){
      if (this.searchText == "") {
        this.$router.push("/search");
      }
      sensors.track("ClickSearch", {
        page_name: this.$route.meta.title,
      });
    },
    clear(){
      sensors.track("Click_fork", {
        classification: '辅食专栏',
      });
    },
    onCancel(){
      this.$router.go(-1)
    },
    // 获取搜索结果
    getSearchList: Debounce(function () {
      if (this.searchText == "") return false;
      this.noContent = true;
      API.getSearch(
        'recipeFoodsSearch',
        {
          content: this.searchText,
          page: this.searchResultParams.page,
          size: this.searchResultParams.size,
        },
        (res) => {
          var historyFlag = false;
          this.historyVal.forEach((item) => {
            if (item == this.searchText) {
              historyFlag = true;
            }
          });
          if (res.code === "200") {
            this.flag = false;
            if (res.data.content != null) {
              this.articleList = this.articleList.concat(res.data.content);
              this.articleList.forEach((item)=>{
                if(item.recipeTag != null ){
                  item.recipeTag = item.recipeTag.split(',')
                  // item.recipeTag = '我是,撒打发但,十大发射,的萨芬萨的,而无法违法,ssdfdsa,cvadfvddf,vavdsv,dsvav,asdvas,dsavasdv'.split(',')

                }
              })
              if (this.searchResultParams.page >=Math.ceil(res.data.totalElements / this.searchResultParams.size) || Math.ceil(res.data.totalElements / this.searchResultParams.size) === 0) {
                this.searchLoadingObj.expertFinished = true;
                this.searchLoadingObj.finishText = "————已经到底了————";
              } else {
                this.searchResultParams.page += 1;
              }

              if (this.searchResultParams.page == 1 && res.data.content.length == "0") {
                this.searchLoadingObj.finishText = "";
                this.noContent = false;
              }
              sensors.track("ResultPage", {
                key_word: this.searchText,
                is_history: historyFlag,
                is_successful: true,
                search_number: res.data.content.length,
                page_name: document.title,
                classification: '辅食专栏',
              });
            } else {
              sensors.track("ResultPage", {
                key_word: this.searchText,
                is_history: historyFlag,
                is_successful: false,
                search_number: 0,
                page_name: document.title,
                classification: '辅食专栏',
              });

              this.searchLoadingObj.expertLoading = false;
              this.searchLoadingObj.expertError = true;
              if (res.data.content == [] || res.data.content == "" || res.data.content == null ) {
                this.noContent = false;
                this.searchLoadingObj.expertErrorText = "";
              }
            }
          }
        }
      );
    }, 300),
    // 跳转详情
    clickRusult(item,index){
      var historyFlag = false;
      this.historyVal.forEach((items) => {
        if (items == this.searchText) {
          historyFlag = true;
        }
      });
      sensors.track("ClickSearchResult", {
        key_word: this.searchText,
        is_history: historyFlag,
        search_number: this.articleList.length,
        click_position: index + 1,
        classification: '辅食专栏',
      });
      sensors.track("details_click",{
        content_title: item.recipe_name
      });
      setTimeout(()=>{
        location.href = '/foodColumn/foodDetail/'+item.id
        // this.$router.push({path:'/foodColumn/foodDetail/'+item.id})
      },200)
    },
    TestUserAgent,
    fomatterNum,
    Debounce,
    uniqueArr
  }
}
</script>
